import {
  DEFAULT_ANCHOR_BY_TYPE,
  DEFAULT_THICKNESS,
  ElementState,
  ElementType,
  Symbol as SymbolElement,
  SymbolType,
} from '@ritabygglov/core';
import { symbolRegistry } from '../symbolRegistry';

export const createSymbol = (
  initialX: number,
  initialY: number,
  renderingOrder: number,
  id: string,
  userId: string,
  symbolType = SymbolType.WELL,
  options: Partial<SymbolElement> = {}
): SymbolElement => {
  return {
    type: ElementType.Symbol,
    state: ElementState.Creation,
    rotate: 0,
    renderingOrder,
    userVersion: {
      userId,
      version: 1,
    },
    symbolType,
    width: symbolRegistry[symbolType].defaultWidth,
    height: symbolRegistry[symbolType].defaultHeight,
    text: '',
    showDimensions: false,
    thickness: DEFAULT_THICKNESS,
    thicknessAnchor: DEFAULT_ANCHOR_BY_TYPE[ElementType.Symbol],
    ...options,
    x: initialX,
    y: initialY,
    id,
  };
};
